import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ProspectAggregatorNameForm({ prospectAggregatorName }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Aggregator name:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="aggregatorName"
          id="aggregatorName"
          value={prospectAggregatorName || ''}
          disabled
        />
      </Col>
    </>
  );
}

export default memo(ProspectAggregatorNameForm);
